import { render, staticRenderFns } from "./SizeChartMenu.vue?vue&type=template&id=0acca8ac&scoped=true&"
import script from "./SizeChartMenu.vue?vue&type=script&lang=js&"
export * from "./SizeChartMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acca8ac",
  null
  
)

export default component.exports